import { CollectionConfig } from "@rebasepro/types";
import companiesCollection from "./companies";

const profileViewsCollection: CollectionConfig = {
    name: "Perfiles consultados",
    singularName: "Perfil consultado",
    slug: "profile-views",
    table: "profile_views",
    securityRules: [
        {
            // A talent sees who viewed their profile; they never write these.
            name: "talent_read_own_views",
            operation: "select",
            using: "auth.uid() = talent_auth_user_id"
        },
        {
            // Only a member of the viewing company can log a view as that
            // company, so the viewer column cannot be forged.
            name: "company_log_view",
            operation: "insert",
            using: "EXISTS (SELECT 1 FROM company_members cm WHERE cm.auth_user_id = auth.uid() AND cm.company_id = profile_views.viewer_company_id)",
            withCheck: "EXISTS (SELECT 1 FROM company_members cm WHERE cm.auth_user_id = auth.uid() AND cm.company_id = profile_views.viewer_company_id)"
        },
        {
            name: "admin_full_access",
            operation: "all",
            roles: ["admin"]
        }
    ],
    properties: {
        id: {
            name: "ID",
            type: "string",
            isId: "uuid"
        },
        // This table is an append-only audit trail written by the app when a
        // company opens a candidate. Every column is machine-written, so the
        // whole row is read-only in the admin: a hand-edited view record is
        // indistinguishable from a real one and silently corrupts the trail.
        talent_auth_user_id: {
            name: "Perfil consultado",
            type: "string",
            userSelect: true,
            description: "Usuario cuyo perfil fue consultado",
            validation: {
                required: true
            },
            admin: { readOnly: true }
        },
        viewer_company_id: {
            name: "Empresa que consultó",
            type: "relation",
            relation: {
                kind: "belongsTo",
                target: () => companiesCollection,
                localKey: "viewer_company_id"
            },
            description: "La empresa que consultó el perfil",
            validation: { required: true },
            admin: { readOnly: true }
        },
        created_at: {
            name: "Creado",
            type: "date",
            autoValue: "on_create"
        }
    },
    admin: {
        // Append-only audit trail. It belongs as the "Perfiles consultados" tab
        // on a company; a flat list of every view ever recorded answers no
        // question anyone actually asks.
        //
        // Out of the drawer, kept as the "Perfiles consultados" tab on a
        // company. `hideFromNavigation` is drawer-only now; use
        // `hideFromEntityViews` to suppress a tab. See company_members.ts.
        hideFromNavigation: true,
        group: "Empresas",
        icon: "Visibility",
        sort: ["created_at", "desc"],
        listProperties: ["created_at"],
        // Identity first — a date is not a row title.
        previewProperties: ["talent_auth_user_id", "created_at"]
    }
};

export default profileViewsCollection;
